import { render, staticRenderFns } from "./PostprocessingToApply.vue?vue&type=template&id=46d459a8&scoped=true&"
import script from "./PostprocessingToApply.vue?vue&type=script&lang=js&"
export * from "./PostprocessingToApply.vue?vue&type=script&lang=js&"
import style0 from "./PostprocessingToApply.vue?vue&type=style&index=0&id=46d459a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d459a8",
  null
  
)

export default component.exports